import React from 'react';
import './MessageBar.css';
import { Message } from "../../Types/MessageTypes";

interface Props {
  message: Message;
  onDismiss?: (key: string) => void;
}

const MessageBar: React.FC<Props> = ({ message, onDismiss }) => {
  const { key, type, content, dismissible = true } = message;

  return (
    <div className={`message-bar message-${type}`} role="alert">
      <span>{content}</span>
      {dismissible && onDismiss && (
        <button onClick={() => onDismiss(key)} aria-label="Dismiss">
          x
        </button>
      )}
    </div>
  );
};

export default MessageBar;
